import React from 'react';
import {Table as BaseTable} from 'desktop/sports/nba/players-list/classic';

class Table extends BaseTable {}

export {Table};
